import { render, staticRenderFns } from "./new1.vue?vue&type=template&id=7b7e9b90&"
import script from "./new1.vue?vue&type=script&lang=js&"
export * from "./new1.vue?vue&type=script&lang=js&"
import style0 from "./new1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports